import { Box, Button, Grid, Typography } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import pluralize from 'pluralize'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { noLocationRoute } from '../../routes/routes'
import GoogleMap from './GoogleMap'
import LocationSearchBox from './LocationSearchBox'

const LocationsList = ({ goToLocation, isOpenId, locations, onClickOverride, onToggleOpen }) => (
  <div className="searchLocationsList" id="searchLocationsList">
    {locations.map((location, i) => {
      const selected = isOpenId === location.deliveryLocationId
      return (
        <Box
          border="solid 1px #e1e1e1"
          borderRadius="4px"
          className="searchLocationListItem"
          data-selected={selected}
          id={`searchLocation-${location.deliveryLocationId}`}
          key={i}
          marginBottom={3}
          onClick={() =>
            onClickOverride ? onClickOverride(location) : goToLocation(location.deliveryLocationId)
          }
          onMouseOut={() => onToggleOpen(location.deliveryLocationId)}
          onMouseOver={() => onToggleOpen(location.deliveryLocationId)}
          padding="8px"
          textAlign="left"
        >
          <Typography gutterBottom noWrap variant="subtitle2">
            {location.locationName}
          </Typography>
          <Typography display="block" noWrap variant="caption">
            {location.deliveryLine1}
          </Typography>
          <Typography display="block" gutterBottom noWrap variant="caption">
            {location.lastLine}
          </Typography>
          <Grid container justify="space-between">
            <Grid item>
              <Button
                color="primary"
                disableElevation
                endIcon={<ChevronRight />}
                onClick={e => {
                  e.stopPropagation()
                  onClickOverride
                    ? onClickOverride(location)
                    : goToLocation(location.deliveryLocationId)
                }}
                size="small"
              >
                Select this location
              </Button>
            </Grid>
          </Grid>
        </Box>
      )
    })}
  </div>
)

const SelectLocation = ({
  address,
  clearSearch,
  goToLocation,
  lat,
  lng,
  locations = [],
  search,
  showError,
  submitting,
  updateAddress,
  onClickOverride,
}) => {
  const [isOpenId, setIsOpenId] = useState()
  const onToggleOpen = id => {
    if (id === isOpenId) {
      setIsOpenId(undefined)
    } else {
      setIsOpenId(id)
    }
  }
  return (
    <div className="row center-xs">
      <div className="col-xs-12">
        <div style={{ marginBottom: '16px ' }}>
          <h1 className="title" style={{ marginBottom: '16px ' }}>
            {locations && locations.length > 0
              ? `There ${pluralize('is', locations.length)} ${
                  locations.length
                } Foodsby delivery ${pluralize('location', locations.length)} near ${address}`
              : "Sorry, it looks like we don't service your area yet."}
          </h1>
          {/* If no search function is passed in, assume it's just a location picker */}
          {search && (
            <LocationSearchBox
              address={address}
              redirectOverride={true}
              search={search}
              showError={showError}
              submitting={submitting}
              updateAddress={updateAddress}
            />
          )}
        </div>
        <div className="row">
          <div
            className={
              locations && locations.length === 0 ? 'col-xs-12' : 'col-xs-12 col-sm-7 col-lg-8'
            }
          >
            <GoogleMap
              goToLocation={goToLocation}
              isOpenId={isOpenId}
              lat={lat}
              lng={lng}
              locations={locations || []}
              onClickOverride={onClickOverride}
              onToggleOpen={onToggleOpen}
            />
          </div>
          {locations && locations.length > 0 && (
            <div className="col-xs-12 col-sm-5 col-lg-4">
              <LocationsList
                clearSearch={clearSearch}
                goToLocation={goToLocation}
                isOpenId={isOpenId}
                locations={locations}
                onClickOverride={onClickOverride}
                onToggleOpen={onToggleOpen}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const RequestFoodsbyLink = () => (
  <div className="row center-xs">
    <div className="col-xs-12">
      <div style={{ marginTop: '16px' }}>
        Can&apos;t find Foodsby at your address?{' '}
        <Link to={noLocationRoute.path}>Request Foodsby</Link>.
      </div>
    </div>
  </div>
)

export default SelectLocation
